export const paymentMethodMapper = {
  "Πληρωμή στο πρατήριο": "Pay At Station",
  "Πληρωμή online μέσω Viva": "Pay With Viva",
};
